import { useContext, useState } from "react";
import Modal from "../utils/modal";
import Button from "../atoms/button";
import { Field, inputClasses } from "../atoms/formField";
import ToastContext from "../../context/toastProvider";
import AutographNoteSelect from "../serials/AutographNoteSelect";
import { CONDITIONS, CONDITION_LABELS } from "./conditions";
import { extendedArtErrorMessage, finalizeExtendedArtSerial } from "./functions";

/** Finalizar item (spec §5.2, D5): condição única e, se o pedido tiver, nota de autógrafo. */
const FinalizeItemModal = ({ user, order, serial, onDone, onCancel }) => {
    const { goodToast, badToast } = useContext(ToastContext);
    // Item final = correção: reabre com os valores atuais e o backend refaz sem trocar o serial.
    const correcting = !serial.isDraft && Boolean(serial.serialNumber);
    const [condition, setCondition] = useState(serial.condition || "");
    const [nota, setNota] = useState(serial.notaAutografo ?? "");
    const [saving, setSaving] = useState(false);

    const handleSubmit = async () => {
        setSaving(true);
        const body = {
            condition,
            // String do enum do serial comum ("Autentico" | "8" | "9" | "10"), como no contrato.
            ...(order.autographEvaluation && nota !== "" ? { notaAutografo: nota } : {}),
        };
        const out = await finalizeExtendedArtSerial(user?.token, serial._id, body);
        setSaving(false);
        if (out?.type !== "success") {
            badToast(extendedArtErrorMessage(out?.code, out?.message || "Erro ao finalizar o item"));
            return;
        }
        goodToast(correcting ? `Serial ${out.data?.serialNumber} corrigido` : `Serial ${out.data?.serialNumber} gerado`);
        onDone(out.data);
    };

    return (
        <Modal width="min(96%, 480px)">
            <div className="flex flex-col gap-3 p-2 text-left text-laranjinha">
                <h2 className="text-lg font-semibold text-primary">{correcting ? "Corrigir item" : "Finalizar item"}</h2>
                <p className="text-sm text-laranjinha/70">{serial.gradableModel?.name}</p>
                <Field label="Condição" required>
                    <select className={inputClasses} value={condition} onChange={(e) => setCondition(e.target.value)}>
                        <option value="">Escolha…</option>
                        {CONDITIONS.map((c) => <option key={c} value={c}>{`${c} — ${CONDITION_LABELS[c]}`}</option>)}
                    </select>
                </Field>
                {order.autographEvaluation ? (
                    <AutographNoteSelect value={nota} onChange={setNota} className={inputClasses} ariaLabel="Nota do autógrafo" />
                ) : null}
                <div className="flex gap-2">
                    <Button classes="bg-red-300 hover:bg-red-400 px-4" click={onCancel}>Cancelar</Button>
                    <Button classes="bg-green-400 hover:bg-green-300 px-4" click={handleSubmit} disabled={!condition || saving}>{correcting ? "Corrigir" : "Finalizar"}</Button>
                </div>
            </div>
        </Modal>
    );
};

export default FinalizeItemModal;
